import o from "react";
import "../../../../../../../Accordion/Accordion.js";
import "../../../../../../../AdCard/AdCard.js";
import "../../../../../../../AdCardImageCarousel/AdCardImageCarousel.js";
import "../../../../../../../AdMediaCounter/AdMediaCounter.js";
import "../../../../../../../Alertbox/Alertbox.js";
import "../../../../../../../Alertbox/Links.js";
import "../../../../../../../ArrowButton/ArrowButton.js";
import "../../../../../../../Autocomplete/Autocomplete.js";
import "../../../../../../../Autocomplete/AutocompleteListItem.js";
import "../../../../../../../Avatar/Avatar.js";
import { Badge as r } from "../../../../../../../Badge/Badge.js";
import "../../../../../../../Breadcrumb/Breadcrumb.js";
import "../../../../../../../Button/Button.js";
import "../../../../../../../ButtonSocial/ButtonSocial.js";
import "../../../../../../../Card/Card.js";
import "../../../../../../../CardCoverImage/CardCoverImage.js";
import "../../../../../../../CardSuggestion/CardSuggestion.js";
import "../../../../../../../CardTopImage/CardTopImage.js";
import "../../../../../../../Carousel/Carousel.js";
import "../../../../../../../Carousel/components/CarouselNext.js";
import "../../../../../../../Carousel/components/CarouselPrevious.js";
import "../../../../../../../Carousel/components/CarouselContent.js";
import "../../../../../../../Carousel/components/CarouselItem.js";
import "embla-carousel-autoplay";
import "embla-carousel-react";
import "../../../../../../../Checkbox/Checkbox.js";
import "../../../../../../../Chip/Chip.js";
import "../../../../../../../Chips/Chips.js";
import "../../../../../../../Container/Container.js";
import "../../../../../../../Divider/Divider.js";
import "../../../../../../../Dropdown/Dropdown.js";
import "../../../../../../../Flex/Flex.js";
import "../../../../../../../FocusHeader/FocusHeader.js";
import "../../../../../../../Footer/Footer.js";
import "../../../../../../../FormControl/FormControl.js";
import "../../../../../../Header.js";
import "../../../../../../../HelpText/HelpText.js";
import "../../../../../../../IconAction/IconAction.js";
import "../../../../../../../ImageCarousel/ImageCarousel.js";
import "../../../../../../../InputChips/InputChips.js";
import "../../../../../../../LayoutContainer/LayoutContainer.js";
import "../../../../../../../Link/Link.js";
import "../../../../../../../LogoCompraSegura/LogoCompraSegura.js";
import "../../../../../../../LogoOLX/LogoOLX.js";
import "../../../../../../../LogoOLXPay/LogoOLXPay.js";
import "../../../../../../../LogoOLXPayPlusDelivery/LogoOLXPayPlusDelivery.js";
import "../../../../../../../Lurker/Lurker.js";
import "../../../../../../../MediaCounter/MediaCounter.js";
import "../../../../../../../Modal/Modal.js";
import "../../../../../../../Multiselect/Multiselect.js";
import "../../../../../../../Navbar/Navbar.js";
import "../../../../../../../Overflow/Overflow.js";
import "../../../../../../../PriceReferenceRuler/PriceReferenceRuler.js";
import "../../../../../../../ProgressBar/ProgressBar.js";
import "../../../../../../../ProgressCircle/ProgressCircle.js";
import "../../../../../../../ProgressStepped/ProgressStepped.js";
import "../../../../../../../Radio/Radio.js";
import "../../../../../../../Skeleton/Skeleton.js";
import "../../../../../../../Slider/Slider.js";
import "../../../../../../../Slider/RangeSlider.js";
import "../../../../../../../Spinner/Spinner.js";
import "../../../../../../../Tabs/Tabs.js";
import "../../../../../../../Tabs/components/Tab/Tab.js";
import "../../../../../../../Text/Text.js";
import "../../../../../../../TextArea/TextArea.js";
import "../../../../../../../TextInput/TextInput.js";
import "../../../../../../../Toast/Toast.js";
import "../../../../../../../ToggleSwitch/ToggleSwitch.js";
import "../../../../../../../Tooltip/Tooltip.js";
import "clsx";
const t = () => o.createElement(r, {
  "aria-label": "Novo",
  color: "gradient",
  shape: "pill",
  className: "olx-header__overflow-pro-badge"
}, "Novo");
export { t as NewBadge };